import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TestReports = ({ reports, language }) => {
  // Ensure reports is always an array
  const reportsArray = Array.isArray(reports) ? reports : [];

  const handleDownload = (url, filename) => {
    window.open(url, '_blank');
  };

  const getFileIcon = (type) => {
    switch (type) {
      case 'pdf':
        return 'FileText';
      case 'doc': case'docx':
        return 'FileType';
      case 'xls': case 'xlsx':
        return 'Sheet';
      default:
        return 'File';
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024)?.toFixed(1) + ' KB';
    return (bytes / 1048576)?.toFixed(1) + ' MB';
  };

  const getReportTypeLabel = (type) => {
    const types = {
      quality_analysis: { en: 'Quality Analysis', zh: '质量分析' },
      moisture_content: { en: 'Moisture Content', zh: '水分含量' },
      defect_count: { en: 'Defect Count', zh: '缺陷计数' },
      cupping_score: { en: 'Cupping Score', zh: '杯测评分' },
      certification: { en: 'Certification', zh: '认证' },
      other: { en: 'Other', zh: '其他' }
    };
    return types?.[type]?.[language] || type;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-xl font-heading font-semibold mb-6">
        {language === 'en' ? 'Test Reports & Documents' : '测试报告和文件'}
      </h2>
      <div className="space-y-3">
        {reportsArray?.map((report, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-4 bg-muted rounded-lg hover:bg-muted/80 transition-smooth"
          >
            <div className="flex items-center gap-3 flex-1">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={getFileIcon(report?.fileType)} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{language === 'en' ? report?.reportNameEn : report?.reportNameZh}</p>
                <div className="flex items-center gap-3 text-sm text-muted-foreground mt-1">
                  <span className="uppercase">{report?.fileType}</span>
                  <span>•</span>
                  <span>{formatFileSize(report?.fileSizeBytes)}</span>
                  {report?.testDate && (
                    <>
                      <span>•</span>
                      <span>{new Date(report?.testDate)?.toLocaleDateString(language === 'en' ? 'en-US' : 'zh-CN')}</span>
                    </>
                  )}
                </div>
                {report?.laboratoryName && (
                  <p className="text-xs text-muted-foreground mt-1">{report?.laboratoryName}</p>
                )}
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={() => handleDownload(report?.fileUrl, language === 'en' ? report?.reportNameEn : report?.reportNameZh)}
            >
              {language === 'en' ? 'Download' : '下载'}
            </Button>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" />
          <p className="text-sm text-muted-foreground">
            {language === 'en' ?'All test reports are conducted by certified laboratories and include detailed analysis of quality parameters, moisture content, and defect counts.' :'所有测试报告均由认证实验室进行，包括质量参数、水分含量和缺陷计数的详细分析。'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestReports;